Product Reference: {{ data.line.Reference }}<br/>
Description: {{ data.line.Description }}<br/>
Estimated Unit Price: {{ data.line.EstimatedUnitPrice | number:'1.2-2' }}<br/>

<table>
  <thead>
    <th><u>Order Reference</u></th>
    <th><u>Line</u></th>
    <th><u>Quantity</u></th>
    <th><u>Quoted Unit Price</u></th>
    <th><u>Discount</u></th>
    <th><u>Discounted Price</u></th>
  </thead>
  <tbody>
    <tr>
      <td>{{order.SOReference}}</td>
      <td>{{line.POLine}}</td>
      <td>{{line.Quantity}}</td>
      <td>{{line.UnitPrice | number:'1.2-2'}}</td>
      <td>{{line.CustomerDiscount}}%</td>
      <td>{{(line.UnitPrice ?? 0) * (1 - ((line.CustomerDiscount ?? 0) / 100)) | number:'1.2-2'}}</td>
    </tr>
    <tr *ngFor="let d of duplicates">
      <td>{{d.SOReference}}</td>
      <td>{{d.POLine}}</td>
      <td>{{d.Quantity}}</td>
      <td>{{d.QuotedUnitPrice | number:'1.2-2'}}</td>
      <td>{{d.CustomerDiscount}}%</td>
      <td>{{d.QuotedUnitPrice * (1 - (d.CustomerDiscount / 100)) | number:'1.2-2'}}</td>
    </tr>
  </tbody>
</table>